import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  activeStatus: {
    color: theme.palette.success.main,
    textTransform: 'capitalize',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  wrap: {
    '& div': {
      whiteSpace: 'pre-wrap !important',
    },
  },
  status: {
    paddingLeft: '10px',
    position: 'relative',
    '&::before': {
      content: "''",
      position: 'absolute',
      width: 5,
      height: 5,
      borderRadius: '50%',
      bottom: '5px',
      backgroundColor: theme.palette.grey[500],
    },
    '& .status': {
      textTransform: 'capitalize',
      marginLeft: '10px',
    },
  },
  reserved: {
    '&::before': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  inprogress: {
    '&::before': {
      backgroundColor: theme.palette.success.main,
    },
  },
  startexchange: {
    '&::before': {
      backgroundColor: theme.palette.success.main,
    },
  },
  endexchange: {
    '&::before': {
      backgroundColor: theme.palette.success.main,
    },
  },
  completed: {
    '&::before': {
      backgroundColor: theme.palette.success.main,
    },
  },
  usercancelled: {
    '&::before': {
      backgroundColor: theme.palette.error.main,
    },
  },
  admincancelled: {
    '&::before': {
      backgroundColor: theme.palette.error.main,
    },
  },
  noshow: {
    '&::before': {
      backgroundColor: '#F56A00',
    },
  },
  rejected: {
    '&::before': {
      backgroundColor: theme.palette.error.main,
    },
  },
  timezone: {
    color: theme.palette.secondary.light,
    fontSize: theme.typography.pxToRem(13),
  },
}));

const tableStyles = {
  rows: {
    style: {
      height: 'auto',
    },
  },
};

export { useStyles, tableStyles };
